
        Component.define('box-item-files', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);

$document.on('click', '[data-component="box-item-files"] .btn-remove', function(e){
    e.preventDefault();
    const $this = $(this);
    const id = $(this).attr('data-id');
    const url = $(this).attr('href');

    $('[data-component="modal-download-center"]').trigger('file:remove', [id, url]);
});

        });